module.exports = __webpack_public_path__ + "static/media/GridViewOnIcon.12e10087.svg";